import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css'
})
export class FooterComponent implements OnInit {
  constructor() { }

  ngOnInit(): void {
  }

  copyright() {
    const datePipe = new DatePipe('en-US');
    return datePipe.transform(Date.now(), 'yyyy');
  }

}
